import { render } from "./AppRestrictedState.vue?vue&type=template&id=bf68b078"
import script from "./AppRestrictedState.vue?vue&type=script&lang=js"
export * from "./AppRestrictedState.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__